// eslint:disable no-use-before-declare no-console
import * as React from 'react';
import { ConnectedComponentProps, InitialUiEngineProps } from '../types-uischema';
import { debounceRender } from 'ui/common/debounce-render';
import { connectComponent } from 'app/infrastructure/ui/renderer/field-connector';

/**
 * Connects a field to the redux store and recurses it's children
 *
 * @param hostProps props of the component hosting the root Field instance, usually the EntityView
 */
export const Expand = (hostProps: InitialUiEngineProps): JSX.Element => {
  const descriptor = hostProps.componentDescriptor;
  const ConnectedComponent = connectComponent(hostProps);

  let children = descriptor.children && descriptor.children.map((c: any) =>
    <Field key={`${c.id}`} {...hostProps} componentDescriptor={c} />
  );

  if ( Array.isArray(children) && !children.length){
    children = null;
  }

  return <ConnectedComponent>{children}</ConnectedComponent>;

};

/**
 * Field is data value connected to a single component.
 *
 *  - It can recurse additional Fields from prop `children`
 *
 */
export class FieldComponent extends React.Component<InitialUiEngineProps | ConnectedComponentProps>{

  private componentTree: any;

  /**
   * We build our UI once, and never again as long as the UI definition has not changed
   *
   * @param props
   */
  constructor(props: any) {
    super(props);
    this.componentTree = Expand(props);
  }

  /**
   * If a parent components tells us to render the view
   * we obey.
   *
   * @param next
   */
  public componentDidUpdate(prev: any) {
    if (this.props.reconnect && !(prev as any).reconnect) {
      this.componentTree = Expand(this.props as any);
     }
  }

  /**
   * As long as nothing indicates that different components
   * should render to display our view, we return the already
   * calculated VDOM tree, otherwise the CPU will go nuts
   */
  public render(): any {
    return this.componentTree;
  }
}

export const Field = debounceRender(FieldComponent);
